import api from '@/api'
import { getLocalData } from '@/config/utils'
import { MINI_PROGRAM_CODES } from '@/config/constants'
/**
 * 小程序内H5页面跳转小程序指定页面
 * @param {string} type 小程序页面：download、H5、index
 * @param {string} h5Url 小程序页面内嵌h5链接：type必须为H5，h5Url可以为/unicom/xx，或者完整url
 * @returns
 */
export const openMinProgram = (type = 'index') => {
  const lzCode = getLocalData('lzCode')
  if (lzCode === MINI_PROGRAM_CODES.YHAI && ['index', 'mine'].includes(type)) {
    window.wx.miniProgram.switchTab({ url: `/pages/${type}/index` })
  }
  window.wx.miniProgram.reLaunch({ url: `/pages/${type}/index` })
}

/**
 * 站外打开并跳转微信小程序指定页面
 * @param {string} type 小程序页面：download、H5、index
 * @param {string} h5Url 小程序页面内嵌h5链接：type必须为H5，h5Url可以为/unicom/xx，或者完整url
 * @returns
 */
export const openJumpMinProgram = (type = 'index', h5Url, channelCode) => {
  if (h5Url && !h5Url.startsWith('https')) {
    h5Url = window.location.origin + h5Url
  }
  const params = type ? { backUrl: `/pages/${type}/index` } : {}
  if (h5Url) params.query = `url=${encodeURIComponent(`${h5Url}`)}`
  if (channelCode) params.channelCode = channelCode
  api.sysMiniprogram.getSchemeUrl.post(params).then(res => {
    if (res.code !== 1000) return this.$toast(res.msg)
    if (res.data) {
      location.href = res.data
    }
  })
}
